<template>
  <div class="year-picker">
    <button class="is-pulled-left button white-button" disabled @click="changeYear('subOne')">
      <i class="icon-angle-left" aria-hidden="true" />
    </button>
    <div class="selected-year">
      <p>{{ currentYearDate | dateFormat("yyyy", false) | localeYearDateModifier(language) }}</p>
    </div>
    <button class="is-pulled-right button white-button" :disabled="isThisYear" @click="changeYear('addOne')">
      <i class="icon-angle-right" aria-hidden="true" />
    </button>
  </div>
</template>

<script>
import { isSameYear } from "date-fns";

export default {
  props: {
    currentYearDate: {
      type: Date,
      default: new Date(),
    },
    language: {
      type: String,
      default: "",
    },
  },
  computed: {
    isThisYear() {
      return isSameYear(this.currentYearDate, new Date());
    },
  },
  methods: {
    changeYear(change) {
      this.$emit("year-change", change);
    },
  },
};
</script>

<style scoped lang="scss">
.year-picker {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 150px;

  .selected-year {
    font-size: 20px;
  }
}
</style>
